import DepositoManagementPage from './index.vue'
export default DepositoManagementPage
